import React from "react";
import "./App.css";

import Bookstore from "./components/Bookstore";

function App() {
  return (
    <div>
      <Bookstore />
    </div>
  );
}

export default App;
